var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wapper",style:({height:_vm.height+'px'})},[_c('div',{staticClass:"loading-item",style:({height:_vm.itemHeight+'px',width:_vm.itemHeight+'px',top: _vm.itemTop + 'px'})}),_vm._v(" "),_c('div',{staticClass:"loading-text",style:({top: _vm.textTop + 'px'})},[_vm._v("Loading...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e61e52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/loading.vue
// module id = null
// module chunks = 